import { Routes } from '@angular/router';
import { MainLayoutComponent } from './components/layout/main-layout/main-layout.component';
import {
  AuthComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
} from './pages';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    children: [
      { path: '', component: AuthComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard/citizens',
        loadComponent: () =>
          import('./pages/dashboard/citizen-overview-page/citizen-overview-page.component').then(
            (m) => m.CitizenOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/complaints',
        loadComponent: () =>
          import('./pages/dashboard/complaints-overview-page/complaints-overview-page.component').then(
            (m) => m.ComplaintsOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/cases',
        loadComponent: () =>
          import('./pages/dashboard/cases-overview-page/cases-overview-page.component').then(
            (m) => m.CasesOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/cases/:id',
        loadComponent: () =>
          import('./pages/dashboard/case-detail-overview-page/case-detail-overview-page.component').then(
            (m) => m.CaseDetailComponent,
          ),
      },
      {
        path: 'dashboard/analytics',
        loadComponent: () =>
          import('./pages/dashboard/analytics-overview-page/analytics-overview-page.component').then(
            (m) => m.AnalyticsOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/organization',
        loadComponent: () =>
          import('./pages/dashboard/organization-overview-page/organization-overview-page.component').then(
            (m) => m.OrganizationOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/accounts',
        loadComponent: () =>
          import('./pages/dashboard/accounts-overview-page/accounts-overview-page.component').then(
            (m) => m.AccountsOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/organization/:id',
        loadComponent: () =>
          import('./pages/dashboard/organization-detail-page/organization-detail-page.component').then(
            (m) => m.OrganizationDetailPageComponent,
          ),
      },
      {
        path: 'dashboard/citizens/:id',
        loadComponent: () =>
          import('./pages/dashboard/citizen-detail-page/citizen-detail-page.component').then(
            (m) => m.CitizenDetailPageComponent,
          ),
      },
      {
        path: 'dashboard/announcements',
        loadComponent: () =>
          import('./pages/dashboard/announcements-overview-page/announcements-overview-page.component').then(
            (m) => m.AnnouncementsOverviewPageComponent,
          ),
      },
      {
        path: 'dashboard/tipoffs',
        loadComponent: () =>
          import('./pages/dashboard/tipoffs-overview-page/tipoffs-overview-page.component').then(
            (m) => m.TipoffsOverviewPageComponent,
          ),
      },
      {
        path: 'users',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('./pages/users/user-list/user-list.component').then(
                (m) => m.UserListComponent,
              ),
          },
          {
            path: 'roles',
            loadComponent: () =>
              import('./pages/users/user-roles/user-roles.component').then(
                (m) => m.UserRolesComponent,
              ),
          },
        ],
      },
      {
        path: 'settings',
        children: [
          {
            path: 'profile',
            loadComponent: () =>
              import('./pages/settings/profile/profile.component').then(
                (m) => m.ProfileComponent,
              ),
          },
          {
            path: 'security',
            loadComponent: () =>
              import('./pages/settings/security/security.component').then(
                (m) => m.SecurityComponent,
              ),
          },
        ],
      },
      {
        path: 'dashboard/security',
        loadComponent: () =>
          import('./pages/dashboard/system-settings-page/system-settings-page.component').then(
            (m) => m.SystemSettingsPageComponent,
          ),
      },
      {
        path: 'dashboard/e-citizen',
        loadComponent: () =>
          import('./pages/umuturage/umuturage.component').then(
            (m) => m.UmuturageComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
